import axios from 'axios'
import {UserModel} from './_models'
import { getCurrentApiUrl } from '../../../utils/backendConfig'

const getApiUrl = () => getCurrentApiUrl()

export const GET_USER_BY_ACCESSTOKEN_URL = () => `${getApiUrl()}/auth/verify-token`
export const GET_CURRENT_USER_URL = () => `${getApiUrl()}/auth/me` // 🔄 New endpoint for fetching current user
export const LOGIN_URL = () => `${getApiUrl()}/auth/login`
export const REGISTER_URL = () => `${getApiUrl()}/auth/register`
export const FORGET_PASSWORD = () => `${getApiUrl()}/auth/forgot-password`
export const RESET_PASSWORD = () => `${getApiUrl()}/auth/reset-password`
export const VERIFY_EMAIL_URL = () => `${getApiUrl()}/auth/verify-email`
export const RESEND_EMAIL_URL = () => `${getApiUrl()}/auth/resend-link`

// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post<any>(
    LOGIN_URL(),
    {email, password},
    {headers: {skipAuth: true}} // Include skipAuth header to bypass token requirement
  )
}

// Server should return AuthModel
export function register(name: string, email: string, password: string) {
  return axios.post(REGISTER_URL(), {
    name,
    email,
    password,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(FORGET_PASSWORD(), {
    email,
  })
}

// reset password
export function resetPassword(password: string, token: string | undefined) {
  return axios.put<{message: string}>(RESET_PASSWORD(), {
    newPassword: password,
    forgetPasswordToken: token,
  })
}

// verify token
export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL(), {
    auth_token: token,
  }, {
    headers: {
      // Use both auth-token and Authorization headers for Laravel compatibility
      'auth-token': token,
      'Authorization': `Bearer ${token}`
    }
  })
}

// email verification
export function verifyEmail(token: string) {
  return axios.post(VERIFY_EMAIL_URL(), {
    token: token,
  })
}

// resend email verification link
export function resendLink(email: string) {
  return axios.post(RESEND_EMAIL_URL(), {
    email: email,
  })
}

// 🔄 Get current user data (replaces localStorage user storage)
// This will be used once Laravel developer implements /auth/me endpoint
export function getCurrentUser() {
  return axios.get<UserModel>(GET_CURRENT_USER_URL())
}

// 🔄 Helper function to refresh current user data
// Can be called from anywhere in the app to get fresh user data
export function refreshCurrentUser() {
  return getCurrentUser()
}
